'use client';

import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { StyledMain } from './styled/main.styled';

export const Main = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <StyledMain component="main" className={classNames('main', className)}>
      {children}
    </StyledMain>
  );
};
